export enum Day {
	SUNDAY = 1,
	MONDAY = 2,
	TUESDAY = 4,
	WEDNESDAY = 8,
	THURSDAY = 16,
	FRIDAY = 32,
	SATURDAY = 64
}